export const COOKIE_NAME = "app_session_id";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const SESSION_MAX_AGE_MS = 1000 * 60 * 60 * 24 * 7; // 7 dias
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';

/**
 * Piso de caracteres para busca textual de contatos.
 *
 * 3 não é arbitrário: pg_trgm indexa trigramas, então `ILIKE '%ab%'` com menos
 * de 3 caracteres NÃO usa o índice GIN e degrada para seq scan na tabela toda
 * do tenant. Compartilhado para que a UI avise antes de o servidor descartar o
 * termo — se divergirem, o usuário digita e a lista volta inteira sem
 * explicação.
 */
export const MIN_SEARCH_LENGTH = 3;

/**
 * Chave do setting (CSV) com as categorias de notificação que o admin
 * desabilitou para toda a conta.
 *
 * Compartilhada porque três lugares precisam concordar sobre ela: o card do
 * admin em Settings, o `settings.getNotificationPolicy` no servidor e o hook
 * `useDesktopNotifications`. Escrita à mão em cada um, um typo silencioso
 * significaria "admin desliga a categoria e o agente continua recebendo" —
 * sem erro em lugar nenhum.
 */
export const NOTIFICATION_CATEGORIES_DISABLED_KEY = "notification_categories_disabled";

/**
 * Recortes do log por destinatário de uma campanha de e-mail.
 *
 * Compartilhada porque três lugares precisam concordar sobre ela: a query em
 * `server/db/email.ts`, o input do `emailCampaigns.getRecipients` e a tool
 * `email_campaign_report` do MCP. Escrita à mão em cada um, a do MCP ficou sem
 * `pending` e `failed` — e eram justamente os dois que respondem "quem NÃO
 * recebeu", o recorte cuja ausência deixou 14 mil não-envios passarem
 * despercebidos no incidente de 18/08/2026. Pelo MCP, a pergunta era
 * literalmente irrespondível, sem nenhum erro aparecer.
 *
 * Fica em shared/ e não em server/db porque as tools do MCP não importam de
 * `server/db` por invariante de arquitetura (ver cabeçalho de server/mcp/tools.ts).
 */
export const CAMPAIGN_RECIPIENT_FILTERS = [
  "all", "sent", "delivered", "opened", "clicked", "bounced",
  "not_opened", "unsubscribed", "pending", "failed",
] as const;

export type CampaignRecipientFilter = (typeof CAMPAIGN_RECIPIENT_FILTERS)[number];
